import React from 'react';
import { useTheme } from '../theme';
import APP_COLOURS from '../config/colors';

const SunIcon = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
  </svg>
);

const MoonIcon = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M21 14.3A8.5 8.5 0 1 1 9.7 3 7 7 0 0 0 21 14.3z" />
  </svg>
);

const MonitorIcon = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <rect x="3" y="4" width="18" height="12" rx="2" />
    <path d="M8 20h8M12 16v4" />
  </svg>
);

export const ThemeToggle = ({ compact = false }) => {
  const { scheme, toggle } = useTheme();
  const isDark = scheme === 'dark';
  const size = compact ? 32 : 36;

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Light mode' : 'Dark mode'}
      className="theme-toggle"
      style={{
        width: size,
        height: size,
        color: APP_COLOURS.TEXTCOLOR,
        backgroundColor: APP_COLOURS.BG4,
        border: `1px solid ${APP_COLOURS.CARD_BORDER}`,
      }}
    >
      {isDark ? <SunIcon size={compact ? 14 : 16} /> : <MoonIcon size={compact ? 14 : 16} />}
    </button>
  );
};

const OPTIONS = [
  { id: 'light', label: 'Light', Icon: SunIcon },
  { id: 'dark', label: 'Dark', Icon: MoonIcon },
  { id: 'system', label: 'System', Icon: MonitorIcon },
];

export const ThemeSegmented = () => {
  const { mode, setMode } = useTheme();

  return (
    <div
      className="theme-segmented"
      role="radiogroup"
      aria-label="Appearance"
      style={{
        backgroundColor: APP_COLOURS.BG4,
        border: `1px solid ${APP_COLOURS.CARD_BORDER}`,
      }}
    >
      {OPTIONS.map(({ id, label, Icon }) => {
        const active = mode === id;
        return (
          <button
            key={id}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => setMode(id)}
            className={`theme-segmented-btn${active ? ' is-active' : ''}`}
            style={{
              color: active ? APP_COLOURS.TEXTCOLOR : APP_COLOURS.PLACEHOLDER,
              backgroundColor: active ? APP_COLOURS.CARD : 'transparent',
              boxShadow: active ? `0 1px 2px ${APP_COLOURS.SHADOW}` : 'none',
            }}
          >
            <Icon size={13} />
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default ThemeToggle;
